import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import "flatpickr/dist/flatpickr.min.css"
import { Italian } from "flatpickr/dist/l10n/it.js"

export default class extends Controller {
  connect() {
    const el = this.element
    const options = {
      locale: Italian,
      dateFormat: "Y-m-d",
      altFormat: "d-m-Y",
      mode: "single"
    }

    if (el.classList.contains("flatpickr_time_range")) {
      options.enableTime = true
      options.mode = "range"
      options.dateFormat = "Y-m-d H:i"
      options.altFormat = "d-m-Y H:i"
      options.allowInput = true
    } else if (el.classList.contains("flatpickr_range")) {
      options.mode = "range"
      options.allowInput = true
    } else if (el.classList.contains("flatpickr_time")) {
      options.enableTime = true
      options.dateFormat = "Y-m-d H:i"
      options.altFormat = "d-m-Y H:i"
    }

    flatpickr(el, options)
  }
}
